'use client'

import { PropsWithChildren } from 'react'

import { useBIPageView } from '@/context/BISdkContext'
import { useUAContext } from '@/context/UAContext'
import { useWorldSearchContext } from '@/context/WorldSearchContext'
import { cn } from '@/lib/utils'

export default function GameLayoutWrapper({ children }: PropsWithChildren) {
  const { mobileNavHeight } = useWorldSearchContext()
  const { isMobileApp } = useUAContext()

  useBIPageView()

  return (
    <main className="flex flex-1 flex-col gap-6" style={{ marginBottom: mobileNavHeight }}>
      <div
        className={cn('flex flex-col gap-6', isMobileApp ? 'pt-0' : 'pt-8')}
      >
        {children}
      </div>
    </main>
  )
}
